import { ControlFacet } from '../models/controls/ControlFacet';

export const itemsScopeControl = new ControlFacet<{}, {
  itemsScopeItemKey: string;
}>('itemsScopeControl');
